import { render, staticRenderFns } from "./RebuildIndividualContact.vue?vue&type=template&id=2dd745db&scoped=true"
import script from "./RebuildIndividualContact.vue?vue&type=script&lang=js"
export * from "./RebuildIndividualContact.vue?vue&type=script&lang=js"
import style0 from "./RebuildIndividualContact.vue?vue&type=style&index=0&id=2dd745db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd745db",
  null
  
)

export default component.exports